import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["url", "title", "description", "imageUrl", "source", "fetchButton", "fetchError"]
  static values = {
    fetchUrl: String
  }

  connect() {
    if (this.urlTarget.value.trim()) {
      this.fetchButtonTarget.click()
    }
  }

  async fetch(event) {
    event.preventDefault()

    const url = this.urlTarget.value.trim()
    if (!url) return

    this.setLoading(true)
    this.clearError()

    try {
      const response = await fetch(this.fetchUrlValue, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({ url })
      })

      const data = await response.json()

      if (data.success) {
        this.populateFields(data)
      } else {
        this.showError(data.error)
      }
    } catch (error) {
      this.showError("Failed to fetch URL")
    } finally {
      this.setLoading(false)
    }
  }

  populateFields(data) {
    if (data.title && !this.titleTarget.value) {
      this.titleTarget.value = data.title
    }
    if (data.description && !this.descriptionTarget.value) {
      this.descriptionTarget.value = data.description
    }
    if (data.image_url) {
      this.imageUrlTarget.value = data.image_url
    }
    if (data.source && !this.sourceTarget.value) {
      this.sourceTarget.value = data.source
    }
  }

  setLoading(loading) {
    if (this.hasFetchButtonTarget) {
      this.fetchButtonTarget.disabled = loading
      this.fetchButtonTarget.textContent = loading ? "Fetching..." : "Fetch"
    }
  }

  showError(message) {
    if (this.hasFetchErrorTarget) {
      this.fetchErrorTarget.querySelector("span").textContent = message
      this.fetchErrorTarget.classList.remove("hidden")
    }
  }

  clearError() {
    if (this.hasFetchErrorTarget) {
      this.fetchErrorTarget.querySelector("span").textContent = ""
      this.fetchErrorTarget.classList.add("hidden")
    }
  }
}
